import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MarketingFooter = () => (
  <footer className="marketing-footer">
    <Container>
      <div className="marketing-footer__links">
        <Link to="/about">About</Link>
        <Link to="/shop">Shop</Link>
        <a
          href="https://community.gardensync.com/communities/groups/garden-sync-community/home"
          target="_blank"
          rel="noopener noreferrer"
        >
          Forum
        </a>
        <Link to="/app">Login</Link>
      </div>
      <p className="mb-0 text-app-muted">© 2026 Garden Sync. All rights reserved.</p>
    </Container>
  </footer>
);

export default MarketingFooter;